// extracted by mini-css-extract-plugin
export default {"root":"footer_root__I-Yhn","footer":"footer_footer__aIeo5"};